<template>
  <!-- 类目佣金设置  commissionSettings -->
  <div class="">
    <!--删除列表时使用的是rowKey的id-->
    <x-tabula
      ref="table"
      rowKey="categoryId"
      :dataSource="dataSource"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :rowSelection="false"
    >
    </x-tabula>
  </div>
</template>

<script>

export default {
  name: 'localCommissionSet',
  components: {},
  data () {
    return {
      visible: false,
      rowData: {},
      searchList: [
        {
          inputType: 'input',
          options: [],
          handle: '',
          placeholder: '类目名称',
          props: ['categoryName']
        }
      ],
      tableOptList: [],
      rowOptList: [
        {
          text: '二级类目',
          handle: row => this.toL2(row),
          permi: ['community:category:category2List']
        }
      ],
      columns: [
        {
          title: '类目名称',
          dataIndex: 'categoryName',
          align: '',
          width: '80%'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: '',
          scopedSlots: { customRender: 'action' }
        }
      ],
      dataSource: [],
      searchParams: {
        categoryName: undefined
      },
      listApi: {
        url: '/local/category/category1/list',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      }
    };
  },
  created () {

  },
  methods: {
    toL2 (row) {
      this.$router.push({
        name: 'commissionSetLevel2',
        query: {
          categoryId: row.categoryId
        }
      });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
